import React, { useState } from "react";
import { Box, Avatar, Typography, IconButton, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useGetDirectReports } from "hooks/queries/useGetDirectReports";

const DirectReports = () => {
  const [expanded, setExpanded] = useState(false);
  const { directReports } = useGetDirectReports();

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "start",
        px: "12px",
        py: "7px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 800, opacity: 0.9 }}>
          Direct Reports
        </Typography>
        <IconButton onClick={handleExpand}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={expanded}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {directReports.map((directReport) => (
            <Box
              key={directReport.id}
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                my: "3px",
                cursor: "pointer",
              }}
            >
              <Avatar
                src={directReport.profile_image}
                alt={`${directReport.first_name} ${directReport.last_name}`}
                sx={{ width: 30, height: 30 }}
              />
              <Typography
                variant="body2"
                sx={{
                  ml: 1,
                  "&:hover": {
                    color: "#146ED2",
                  },
                }}
              >
                {directReport.first_name} {directReport.last_name}
              </Typography>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default DirectReports;
